<template>
  <div class="d-flex flex-column" style="height: 100%;">
    <div v-if="history.length > 0" class="mt-4 ml-5 grey--text">
      Select the lead you want to dispute below.
    </div>

    <div v-else class="mt-4 ml-5 grey--text">
      You currently have no disputable leads.
    </div>

    <HistoryList
      :history="history" 
      disputable
      class="rounded-lg mt-4 py-0"
      style="overflow-y: auto"
    />

    <div class="d-flex justify-center">
      <v-btn color="primary" class="mt-3" @click="$router.back()">Back</v-btn>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import HistoryList from '../components/HistoryList'

export default {
  name: 'HistoryDispute',

  components: { HistoryList },

  computed: {
    ...mapGetters('billing', ['history']),
  },

  methods: {
    ...mapActions('billing', ['loadHistory']),
  },

  created() {
    this.loadHistory({ disputable: true })
  }
}
</script>